var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{on:{"click":function($event){return _vm.$emit('toggled', !_vm.active)}}},[_c('label',{attrs:{"for":"pitch"}}),_c('input',{attrs:{"type":"checkbox","id":"toggle","hidden":"","aria-hidden":"true"},domProps:{"checked":_vm.active}}),_c('div',{staticClass:"toggle"})])
}
var staticRenderFns = []

export { render, staticRenderFns }